/** Continue only explicit, unsent proxy-acquisition slices of one operation. */
export function isWaitingForProxy(response, operation) {
  const result = response && response.data;
  const data = result && result.data;
  return Boolean(operation && result && result.code === 30001 && data &&
    data.type === 'proxy_acquisition' && data.submission_state === 'waiting_proxy' &&
    data.can_resend === true && data.operation_id === operation.id &&
    data.operation_step === operation.step);
}

export async function waitForManualProxy(request, operation, {
  isCurrent, onWait, sleep = ms => new Promise(resolve => setTimeout(resolve, ms)),
}) {
  while (isCurrent()) {
    const response = await request();
    if (!isWaitingForProxy(response, operation)) return response;
    if (!isCurrent()) return null;
    onWait();
    const retryAfter = response.data.data.retry_after_seconds;
    const seconds = Number.isFinite(retryAfter) ? Math.max(1, Math.min(8, retryAfter)) : 1;
    await sleep(seconds * 1000);
  }
  return null;
}
